module.exports = __webpack_public_path__ + "static/media/Scaramella-Regular.918231d3.otf";